module.exports = [
  'Addiction Counseling',
  'Art Therapy',
  'Applied Behavior Analysis',
  'Clinical Psychology',
  'Clinical Social Work',
  'Counseling Psychology',
  'Health Psychology',
  'Marriage and Family Therapy',
  'Mental Health Counseling',
  'Neuropsychology',
  'Pastoral Counseling',
  'Professional Counseling',
  'Psychiatric Nursing',
  'Psychiatry',
  'School Psychology',
  'Social Work',
];
